import { styled } from '@mui/material';
import { ReactNode } from 'react';

import { Typography } from '../../../Typography';

export type LabelProps = {
  children: ReactNode;
  variant?: 'side';
  className?: string;
};

const StyledLabel = styled(Typography)<{ labelVariant?: 'side' }>(
  ({ theme, labelVariant }) => ({
    fontSize: 13,
    marginBottom: labelVariant === 'side' ? 0 : theme.spacing(1),
    display: 'block',
    color: 'var(--text-text-primary-color)',
  })
);

export const Label = ({ children, variant, className }: LabelProps) => (
  <StyledLabel component="label" labelVariant={variant} className={className}>
    {children}
  </StyledLabel>
);
